const theme = {
    // Color Palette
    colors: {
      primary: {
        main: '#2563eb',
        light: '#93c5fd',
        dark: '#1e40af',
        contrastText: '#ffffff'
      },
      secondary: {
        main: '#10b981',
        light: '#a7f3d0',
        dark: '#059669',
        contrastText: '#ffffff'
      },
      error: {
        main: '#ef4444',
        light: '#fca5a5',
        dark: '#dc2626',
        contrastText: '#ffffff'
      },
      warning: {
        main: '#f59e0b',
        light: '#fcd34d',
        dark: '#d97706',
        contrastText: '#ffffff'
      },
      success: {
        main: '#10b981',
        light: '#a7f3d0',
        dark: '#059669',
        contrastText: '#ffffff'
      },
      text: {
        primary: '#1e293b',
        secondary: '#64748b',
        disabled: '#94a3b8'
      },
      background: {
        default: '#f8fafc',
        paper: '#ffffff'
      },
      divider: '#e2e8f0'
    },
  
    // Typography
    typography: {
      fontFamily: '"Inter", -apple-system, BlinkMacSystemFont, "Segoe UI", Roboto, Oxygen, Ubuntu, Cantarell, "Open Sans", "Helvetica Neue", sans-serif',
      h1: {
        fontSize: '3rem',
        fontWeight: 700,
        lineHeight: 1.2
      },
      h2: {
        fontSize: '2.5rem',
        fontWeight: 700,
        lineHeight: 1.3
      },
      h3: {
        fontSize: '2rem',
        fontWeight: 600,
        lineHeight: 1.4
      },
      h4: {
        fontSize: '1.5rem',
        fontWeight: 600,
        lineHeight: 1.5
      },
      h5: {
        fontSize: '1.25rem',
        fontWeight: 600,
        lineHeight: 1.6
      },
      h6: {
        fontSize: '1rem',
        fontWeight: 600,
        lineHeight: 1.7
      },
      subtitle1: {
        fontSize: '1rem',
        fontWeight: 500,
        lineHeight: 1.7
      },
      subtitle2: {
        fontSize: '0.875rem',
        fontWeight: 500,
        lineHeight: 1.7
      },
      body1: {
        fontSize: '1rem',
        fontWeight: 400,
        lineHeight: 1.7
      },
      body2: {
        fontSize: '0.875rem',
        fontWeight: 400,
        lineHeight: 1.7
      },
      button: {
        fontSize: '0.875rem',
        fontWeight: 600,
        lineHeight: 1.75,
        textTransform: 'none'
      },
      caption: {
        fontSize: '0.75rem',
        fontWeight: 400,
        lineHeight: 1.6
      },
      overline: {
        fontSize: '0.75rem',
        fontWeight: 600,
        lineHeight: 2.5,
        textTransform: 'uppercase',
        letterSpacing: '0.5px'
      }
    },
  
    // Spacing
    spacing: {
      xs: '4px',
      sm: '8px',
      md: '16px',
      lg: '24px',
      xl: '32px',
      xxl: '48px',
      section: '80px'
    },
  
    // Breakpoints
    breakpoints: {
      xs: '0px',
      sm: '576px',
      md: '768px',
      lg: '992px',
      xl: '1200px'
    },
  
    // Shadows
    shadows: {
      sm: '0 2px 8px rgba(0, 0, 0, 0.08)',
      md: '0 4px 12px rgba(0, 0, 0, 0.1)',
      lg: '0 8px 24px rgba(0, 0, 0, 0.12)',
      xl: '0 12px 32px rgba(0, 0, 0, 0.15)'
    },
  
    // Border Radius
    borderRadius: {
      sm: '4px',
      md: '8px',
      lg: '12px',
      xl: '16px',
      circle: '50%'
    },
  
    // Transitions
    transitions: {
      short: 'all 0.15s ease',
      standard: 'all 0.3s ease',
      long: 'all 0.5s ease'
    },
  
    // Z-index
    zIndex: {
      appBar: 1100,
      drawer: 1200,
      modal: 1300,
      snackbar: 1400,
      tooltip: 1500
    }
  };
  
  // Responsive spacing helper
  theme.spacing.responsive = (value) => {
    if (typeof value === 'number') {
      return `${value * 8}px`;
    }
    return theme.spacing[value] || value;
  };
  
  export default theme;